// Invoice Calculations Hook

export function useInvoiceCalculations() {
  const calculateDueDate = (issueDate: string): string => {
    const date = new Date(issueDate);
    const day = date.getDate();
    const month = day >= 10 ? date.getMonth() + 1 : date.getMonth();
    const year = date.getFullYear();
    
    const dueDate = new Date(year, month, 10);
    return dueDate.toISOString().split('T')[0];
  };

  const calculateNextBillingDate = (): string => {
    const now = new Date();
    const day = now.getDate();
    const month = day >= 10 ? now.getMonth() + 1 : now.getMonth();
    const year = now.getFullYear();
    
    const nextBillingDate = new Date(year, month, 10);
    
    const formatted = nextBillingDate.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    
    return formatted;
  };

  const getInvoicePeriod = (startDate: string, isFirstInvoice?: boolean) => {
    const date = new Date(startDate);
    const periodStart = isFirstInvoice ? startDate : new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
    const periodEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().split('T')[0];
    
    return { periodStart, periodEnd };
  };

  const calculateProportionalAmount = ({ planStartDate, planPrice, isFirstInvoice }: {
    planStartDate: string;
    planPrice: number;
    isFirstInvoice?: boolean;
  }): number => {
    if (!isFirstInvoice) return planPrice;
    
    const startDate = new Date(planStartDate);
    const dayOfMonth = startDate.getDate();
    
    if (dayOfMonth <= 10) return planPrice;
    
    const daysInMonth = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate();
    const daysRemaining = daysInMonth - dayOfMonth + 1;
    const proportionalAmount = (planPrice / daysInMonth) * daysRemaining;
    
    return Math.round(proportionalAmount * 100) / 100;
  };

  return {
    calculateDueDate,
    calculateNextBillingDate,
    getInvoicePeriod,
    calculateProportionalAmount
  };
}

export default useInvoiceCalculations;
